export const FedexWalletService = Object.freeze({
  Ground: '1901',
  Economy: '1902',
  TwoDay: '1903',
  StandardOvernight: '1905',
  PriorityOvernight: '1906',
  InternationalEconomy: '1912',
  InternationalPriority: '1914',
  InternationalConnectPlus: '1919',
  HomeDelivery: '1920',
  TwoDayOneRate: '1921',
  ExpressSaverOneRate: '1922',
  StandardOvernightOneRate: '1923',
  PriorityOvernightOneRate: '1924',
  GroundEconomyParcelSelect: '1925',
});
